const TopicsRouteNavigationOptions = {
  title: 'Topics',
  headerTitle: 'Topics',
  headerBackVisible: false,
};

export default TopicsRouteNavigationOptions;
